module.exports = __webpack_public_path__ + "media/images/emblems/Saicourt-coat_of_arms-bae2666d1e736e9721d123949810828b.svg";